import { Box, LinearProgress, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(3),
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 2000,
  },
}));

function SlashScreen() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Box width={400}>
        <Box p={2} textAlign='center'>
          <Typography variant='h4'>{t('commonUsedWords.loading')}</Typography>
        </Box>

        <LinearProgress />
      </Box>
    </div>
  );
}

export default SlashScreen;
